import { render, staticRenderFns } from "./TrainingSystem_Main.vue?vue&type=template&id=57348901&"
import script from "./TrainingSystem_Main.vue?vue&type=script&lang=js&"
export * from "./TrainingSystem_Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports